import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgClock = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0001 0.935486C4.09857 0.935486 0.935745 4.09831 0.935745 7.99983C0.935745 11.9013 4.09856 15.0642 8.0001 15.0642C11.9017 15.0642 15.0644 11.9013 15.0644 7.99983C15.0644 4.09831 11.9015 0.935486 8.0001 0.935486ZM1.94908 7.99983C1.94908 4.65796 4.65822 1.94881 8.0001 1.94881C11.342 1.94881 14.0511 4.65796 14.0511 7.99983C14.0511 11.3417 11.342 14.0509 8.0001 14.0509C4.65822 14.0509 1.94908 11.3417 1.94908 7.99983ZM8.53334 4.80002C8.53334 4.50547 8.29455 4.26668 8 4.26668C7.70545 4.26668 7.46667 4.50547 7.46667 4.80002V8.00002C7.46667 8.14147 7.52286 8.27712 7.62288 8.37715L9.75622 10.5105C9.96449 10.7187 10.3022 10.7187 10.5105 10.5105C10.7187 10.3022 10.7187 9.96451 10.5105 9.75623L8.53334 7.77911V4.80002Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgClock)
const IconSvgClock = createIcon(ForwardRef, 'SvgClock')
export default IconSvgClock
